import React from 'react';

import { GENERIC_FORM_TYPES, LockboxStatus, LockboxType } from '@/modules/employer/components/Lockbox/lockbox.types';
import { LockboxForm } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxForm/components';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import useClaimRepaymentStatusFields from './hooks/useClaimRepaymentStatusFields';
import useDividedStatusFields from './hooks/useDividedStatusFields';
import useGenericFormStatusFields from './hooks/useGenericFormStatusFields';
import useInboundStatusFields from './hooks/useInboundStatusFields';
import useOutboundStatusFields from './hooks/useOutboundStatusFields';
import useReturnCheckStatusFields from './hooks/useReturnCheckStatusFields';
import useReturnMailStatusFields from './hooks/useReturnMailStatusFields';

const InboundStatusFrom = () => {
  const fields = useInboundStatusFields();
  return <LockboxForm testId="inbound-status" fields={fields} isSmall />;
};

const OutboundStatusFrom = () => {
  const fields = useOutboundStatusFields();
  return <LockboxForm testId="outbound-status" fields={fields} isSmall />;
};

const ClaimRepaymentStatusFrom = () => {
  const fields = useClaimRepaymentStatusFields();
  return <LockboxForm testId="claim-repayment-status" fields={fields} isSmall />;
};

const DividedStatusFrom = () => {
  const fields = useDividedStatusFields(); 
  return <LockboxForm testId="divided-status" fields={fields} isSmall />;
};

const GenericFormStatusFrom = () => {
  const fields = useGenericFormStatusFields();
  return <LockboxForm testId="generic-form-status" fields={fields} isSmall />;
};

const ReturnMailStatusFrom = () => {
  const fields = useReturnMailStatusFields();
  return <LockboxForm testId="return-mail-status" fields={fields} isSmall />;
};

const ReturnCheckStatusFrom = () => {
  const fields = useReturnCheckStatusFields();
  return <LockboxForm testId="return-check-status" fields={fields} isSmall />;
};

const LockboxStatusForm = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const lockboxType = originalLockbox?.lockboxType;

  if (originalLockbox?.lockboxStatus === LockboxStatus.DIVIDED) {
    return <DividedStatusFrom />;
  }

  if (lockboxType === LockboxType.INBOUND_TOA) {
    return <InboundStatusFrom />;
  }

  if (lockboxType === LockboxType.OUTBOUND_TOA) {
    return <OutboundStatusFrom />;
  }

  if (lockboxType === LockboxType.CLAIM_REPAYMENT) {
    return <ClaimRepaymentStatusFrom />;
  }

  if (lockboxType === LockboxType.RETURNED_MAIL) {
    return <ReturnMailStatusFrom />;
  }

  if (lockboxType === LockboxType.RETURNED_CHECK) {
    return <ReturnCheckStatusFrom />;
  }

  if (lockboxType && GENERIC_FORM_TYPES.includes(lockboxType)) {
    return <GenericFormStatusFrom />;
  }

  return null;
};

export default LockboxStatusForm;
